/* The RYG indicator.
 *
 * SIM-06: "Colour is always accompanied by a symbol so that it is readable
 * without colour." The status palette is also reserved - these three colours
 * never serve as a chart series - and ships with an icon AND a label, so
 * meaning never rests on hue alone.
 */

import type { Status } from '../api/client'

export function statusGlyph(status: Status): string {
  if (status === 'LOW') return '▼'   // below the corridor: shortage risk
  if (status === 'HIGH') return '▲'  // above it: cash tied up in stock
  return '●'                          // inside: target
}

export function statusTone(status: Status): 'critical' | 'warning' | 'good' {
  if (status === 'LOW') return 'critical'
  if (status === 'HIGH') return 'warning'
  return 'good'
}

export function StatusChip({ status, label }: { status: Status; label: string }) {
  return (
    <span className={`chip ${statusTone(status)}`}>
      <span aria-hidden="true">{statusGlyph(status)}</span>
      {label}
    </span>
  )
}
